import React from 'react'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import resourceTimelinePlugin from '@fullcalendar/resource-timeline' // a plugin!

function AppointmentList() {
    return (
        <div className="row">
        <div className="col-md-12">
        <FullCalendar schedulerLicenseKey="0999370375-fcs-1616164417"
            plugins={[ dayGridPlugin, resourceTimelinePlugin  ]}
            header={{
                left: "prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay"
            }}
            initialView="dayGridMonth"
            //weekends={false}
            events={[
                { title: 'Appointment', date: '2022-09-14' },
                { title: 'Appointment', date: '2022-09-15' }
            ]}
        />
        </div>
        </div>
    )
}

export default AppointmentList;